<template>
  <PatientListWithVitalSigns />
</template>

<script setup lang="ts">
import PatientListWithVitalSigns from '@/components/patient/components/organisms/PatientListWithVitalSigns.vue'
</script>
